angular.module('impactx.product').directive('ixPriceList', function () {
    return {
        scope: {
            priceList: "=",
            requiredLabel: "=",
            orderUnit: "=",
            dialogData: "=",
            index: "@",
            addEntryLabel: "=",
            eachLabel: "=",
            fromLabel: "=",
            minAmountLabel: "<",
            canDeleteList: "@",
            ixDisabled: "=",
            priceFactor: "=",
            priceOffset: "=",
            maxPriceDigits: "=",
            useMaxPriceDigits: "=",
            useMaxPriceDigitsForAllDerived: "=",
            isDerived: "=",
            useDerivedMaxPriceDigits: "=",
            maxPriceDigitsForDerived: "=",
            intervalLabel: "=",
            allowFracAmounts: "=",
            listName: "@",
            hideToggle: "=",
            noItemsMessage: "@"
        },
        controller: "PriceListCtrl",
        controllerAs: "priceListCtrl",
        restrict:'E',
        templateUrl: 'modules/product/templates/pricelist.tmpl.html',
        transclude:true
    };
});